import React from 'react';
import styled from 'styled-components';
import { Status, ArrowLeftIcon, Button } from '@kvdbil/components';
import { useTranslation } from '~/Locale';

const Container = styled.div`
  border-bottom: ${({ theme }) =>
    `1px solid ${theme.colors.grayscaleToned.light5}`};
  margin-left: -0.75rem;
  padding: 0.25rem 0;
  margin-bottom: 1rem;
`;

interface Props {
  handleClose(): void;
}

const SearchFieldHeader = ({ handleClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Button
        size="small"
        variant="flat"
        color="neutral"
        onClick={handleClose}
        prefixIcon={<ArrowLeftIcon />}
      >
        <Status as="span">{t('Back')}</Status>
      </Button>
    </Container>
  );
};

export default SearchFieldHeader;
